module.exports = __webpack_public_path__ + "img/hub-hero.4141c3a2.svg";